/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Numbers_AtsInputs */

const en_about_numbers_ats = /** @type {(inputs: About_Numbers_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ATS Systems`)
};

const de_about_numbers_ats = /** @type {(inputs: About_Numbers_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ATS-Systeme`)
};

const fr_about_numbers_ats = /** @type {(inputs: About_Numbers_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ATS Systems`)
};

const es_about_numbers_ats = /** @type {(inputs: About_Numbers_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ATS Systems`)
};

const it_about_numbers_ats = /** @type {(inputs: About_Numbers_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ATS Systems`)
};

const nl_about_numbers_ats = /** @type {(inputs: About_Numbers_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ATS Systems`)
};

const pl_about_numbers_ats = /** @type {(inputs: About_Numbers_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ATS Systems`)
};

const fi_about_numbers_ats = /** @type {(inputs: About_Numbers_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ATS Systems`)
};

const da_about_numbers_ats = /** @type {(inputs: About_Numbers_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ATS Systems`)
};

const sv_about_numbers_ats = /** @type {(inputs: About_Numbers_AtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 ATS Systems`)
};

/**
* | output |
* | --- |
* | "12 ATS Systems" |
*
* @param {About_Numbers_AtsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_numbers_ats = /** @type {((inputs?: About_Numbers_AtsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Numbers_AtsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_numbers_ats(inputs)
	if (locale === "fr") return fr_about_numbers_ats(inputs)
	if (locale === "es") return es_about_numbers_ats(inputs)
	if (locale === "it") return it_about_numbers_ats(inputs)
	if (locale === "nl") return nl_about_numbers_ats(inputs)
	if (locale === "pl") return pl_about_numbers_ats(inputs)
	if (locale === "fi") return fi_about_numbers_ats(inputs)
	if (locale === "da") return da_about_numbers_ats(inputs)
	if (locale === "sv") return sv_about_numbers_ats(inputs)
	return en_about_numbers_ats(inputs)
});